import { Grid, Button, CircularProgress } from "@mui/material";
import { useContext, useState } from "react";
import { ThemeContext } from "../../../../contexts";
import { PlanActionsProps } from "../../../../types/components/planActions.types";

import "./planActions.css";

const PlanActions = ({
	waiveButtonCallback,
	activateButtonCallback,
	isWaiveLoading = false
}: PlanActionsProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	// const [isWaiveLoading, setIsWaiveLoading] = useState(false);
	const [isActivateLoading, setIsActivateLoading] = useState(false);

	// const handleWaiveClick = async () => {
	// 	if (waiveButtonCallback) {
	// 		setIsWaiveLoading(true);
	// 		await waiveButtonCallback();
	// 		setIsWaiveLoading(false);
	// 	}
	// };

	const handleActivateClick = async () => {
		setIsActivateLoading(true);
		try {
			await activateButtonCallback();
		} catch (error) {
			// The callback owns user-facing messaging; this only guarantees the button recovers.
			console.error("Activate enrollment failed:", error);
		} finally {
			// Without `finally` a rejected callback left the button disabled on its spinner forever.
			setIsActivateLoading(false);
		}
	};

	return (
		<div className="plan-actions">
			<Grid container spacing={10}>
				<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
					{waiveButtonCallback && (
						<Button
							className="plan-action-button waive"
							variant="contained"
							onClick={waiveButtonCallback}
							disabled={isWaiveLoading}
						>
							{isWaiveLoading ? <CircularProgress size={24} /> : "Waive Enrollment"}
						</Button>
					)}
				</Grid>
				<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
					<Button
						className="plan-action-button"
						style={{ backgroundColor: theme.button.background_color, color: theme.button.color }}
						variant="contained"
						onClick={handleActivateClick}
						disabled={isActivateLoading}
					>
						{isActivateLoading ? <CircularProgress size={24} /> : "Activate Enrollment"}
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default PlanActions;
